export const ICON_NAMES = {
  search: 'search',
  referral: 'referral',
  club: 'club',
  account: 'account',
  cart: 'cart',
  calculator: 'calculator'
};